var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerProp2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_793_83)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8242,
    y: 7,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(24.612 29.8242 7)",
    fill: "#95B5FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 56C50.8366 56 58 48.8366 58 40C58 31.1634 50.8366 24 42 24C33.1634 24 26 31.1634 26 40C26 48.8366 33.1634 56 42 56Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0283 24V55.9994C50.8514 55.9838 57.9996 48.8269 57.9996 40C57.9996 31.1731 50.8514 24.0156 42.0283 24Z",
    fill: "#E20059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7469 35.9625H46.3332C46.18 35.9625 46.0557 35.8381 46.0557 35.685V31.2712C46.0557 30.7762 45.6544 30.375 45.1594 30.375H38.8988C38.4038 30.375 38.0025 30.7762 38.0025 31.2712V35.685C38.0025 35.8381 37.8782 35.9625 37.725 35.9625H33.3113C32.8163 35.9625 32.415 36.3638 32.415 36.8588V43.1194C32.415 43.6144 32.8163 44.0156 33.3113 44.0156H37.725C37.8782 44.0156 38.0025 44.14 38.0025 44.2931V48.7069C38.0025 49.2019 38.4038 49.6031 38.8988 49.6031H45.1594C45.6544 49.6031 46.0557 49.2019 46.0557 48.7069V44.2931C46.0557 44.14 46.18 44.0156 46.3332 44.0156H50.7469C51.2419 44.0156 51.6432 43.6144 51.6432 43.1194V36.8588C51.6432 36.3638 51.2419 35.9625 50.7469 35.9625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7464 35.9625H46.3327C46.1796 35.9625 46.0552 35.8381 46.0552 35.685V31.2712C46.0552 30.7762 45.6539 30.375 45.1589 30.375H42.0283V49.6031H45.1589C45.6539 49.6031 46.0552 49.2019 46.0552 48.7069V44.2931C46.0552 44.14 46.1796 44.0156 46.3327 44.0156H50.7464C51.2414 44.0156 51.6427 43.6144 51.6427 43.1194V36.8588C51.6427 36.3638 51.2414 35.9625 50.7464 35.9625Z",
    fill: "#F4F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_793_83",
    x: 0.62793,
    y: 0.626953,
    width: 83.0264,
    height: 83.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_793_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_793_83",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(26 24)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerProp2);
export default __webpack_public_path__ + "static/media/BannerProp_2.3815e06fe49a5cd54606b9c1d06bc4c1.svg";
export { ForwardRef as ReactComponent };